import React from 'react';
import { SoftBackdrop } from './SoftLayer.js';

/**
 * Кадр серии, которая ещё не вышла: размытая картинка сезона и надпись поверх.
 *
 * Настоящего кадра у такой серии нет или он случайный (промо, заставка), а
 * пустая карточка с цифрой читается как «не загрузилось». Заглушка говорит
 * прямо: серии ещё нет.
 *
 * Размытие — то же, что у фона страницы тайтла: мягкий расфокус (`light`), в
 * котором проступают силуэты и свет, готовым холстом в 160 точек; фильтров на
 * кадре нет. Затемнение стоит следом за холстом и появляется вместе с ним:
 * картинки нет вовсе или она не пришла — видна подложка карточки без кадра
 * (градиент `.episode-still`), надпись та же.
 */
export function EpisodeSoon({ image, date }: { image: string | null; date: string | null }): React.JSX.Element {
  return (
    <span className="episode-soon">
      {image !== null && <SoftBackdrop url={image} className="episode-soon-art" look="light" />}
      <span className="episode-soon-shade" />
      <span className="episode-soon-text">
        <span className="episode-soon-label">Скоро выйдет</span>
        {date !== null && <span className="episode-soon-date">{date}</span>}
      </span>
    </span>
  );
}
